const constructionDocs = [
	{
		code: "aKhatha",
		name: "Construction A Khatha",
		isConstructionDoc: true,
		isKhataDoc: true,
		from: "BBMP",
		shortName: "CA",
	},
	{
		code: "bKhatha",
		name: "Construction B Khatha (No OC)",
		isConstructionDoc: true,
		isKhataDoc: true,
		from: "BBMP",
		shortName: "CB",
	},
	{
		code: "bdaKhatha",
		name: "Construction BDA Khatha",
		isConstructionDoc: true,
		isKhataDoc: true,
		from: "BDA",
		shortName: "C-BDA",
	},
	{
		code: "cmcKhatha",
		name: "Construction CMC Khatha",
		isConstructionDoc: true,
		isKhataDoc: true,
		from: "CMC",
		shortName: "C-CMC",
	},
	{
		code: "eKhatha",
		name: "Construction E Khatha",
		isConstructionDoc: true,
		isKhataDoc: true,
		from: "Panchayath",
		shortName: "CE",
	},
	{
		code: "manualKhatha",
		name: "Construction Manual Khatha",
		isConstructionDoc: true,
		isKhataDoc: true,
		from: "Panchayath",
		shortName: "CM",
	},
	{
		code: "unknownKhatha",
		name: "Construction Khatha Unsure",
		isConstructionDoc: true,
		isKhataDoc: true,
		from: "Unknown",
		shortName: "C (Unsure)",
	},
	{
		code: "eAasthiKhata",
		name: "E Aasthi Khata",
		isConstructionDoc: true,
		from: "BBMP",
		isKhataDoc: true,
		shortName: "C-EA",
	},
	{
		code: "eAasthiKhataFormA",
		name: "Construction E-aasthi khata(Form A)",
		isConstructionDoc: true,
		from: "BBMP",
		isKhataDoc: true,
		shortName: "C-EFA",
	},
	{
		code: "eAasthiKhataFormB",
		name: "Construction E-aasthi khata(Form B)",
		isConstructionDoc: true,
		from: "BBMP",
		isKhataDoc: true,
		shortName: "C-EFB",
	},
	{
		code: "ekhatha11/A",
		name: "Construction E-khatha (11/A)",
		isConstructionDoc: true,
		from: "Panchayath",
		isKhataDoc: true,
		shortName: "C-E11A",
	},
	{
		code: "ekhatha11/B",
		name: "Construction E-khatha (11/B)",
		isConstructionDoc: true,
		from: "Panchayath",
		isKhataDoc: true,
		shortName: "C-E11B",
	},
	{
		code: "cmcEAasthiKhata",
		name: "E-aasthi khata-CMC",
		isConstructionDoc: true,
		from: "CMC",
		isKhataDoc: true,
		shortName: "C-EACMC",
	},
	{
		code: "cmcEmanualKhatha",
		name: "Construction Manual khata-CMC",
		isConstructionDoc: true,
		isKhataDoc: true,
		from: "CMC",
		shortName: "CM",
	},
];

const landKhathaDocs = [
	{
		code: "aKhathaLand",
		name: "Land A Khatha",
		isLandDoc: true,
		isKhataDoc: true,
		from: "BBMP",
		shortName: "LA",
	},
	{
		code: "bKhathaLand",
		name: "Land B Khatha",
		isLandDoc: true,
		isKhataDoc: true,
		from: "BBMP",
		shortName: "LB",
	},
	{
		code: "bdaKhathaLand",
		name: "Land BDA Khatha",
		isLandDoc: true,
		isKhataDoc: true,
		from: "BDA",
		shortName: "L-BDA",
	},
	{
		code: "cmcKhathaLand",
		name: "Land CMC Khatha",
		isLandDoc: true,
		isKhataDoc: true,
		from: "CMC",
		shortName: "L-CMC",
	},
	{
		code: "eKhathaLand",
		name: "Land E Khatha",
		isLandDoc: true,
		isKhataDoc: true,
		from: "Panchayath",
		shortName: "LE",
	},
	{
		code: "manualKhathaLand",
		name: "Land Manual Khatha",
		isLandDoc: true,
		isKhataDoc: true,
		from: "Panchayath",
		shortName: "LM",
	},
	{
		code: "unknownKhathaLand",
		name: "Land Khatha Unsure",
		isLandDoc: true,
		isKhataDoc: true,
		from: "Unknown",
		shortName: "L (Unsure)",
	},
];

export interface DocumentInfo {
	code: string;
	name: string;
	shortName: string;
	isConstructionDoc?: boolean;
	isLandDoc?: boolean;
	isKhataDoc?: boolean;
	from?: string;
	isOc?: boolean;
	isUC?: boolean;
}

export const documentsInfo: DocumentInfo[] = [
	...constructionDocs,
	...landKhathaDocs,
	{ code: "BDA", name: "BDA Layout", shortName: "BDA" },
	{ code: "sanctionedPlan", name: "Sanctioned plan", shortName: "SP" },
	{ code: "masterPlan", name: "Master plan", shortName: "MP" },
	{ code: "dcConversion", name: "DC Conversion", shortName: "DC" },
	{
		code: "occupancyCertificate",
		name: "OC - Received",
		shortName: "OC",
		isOc: true,
		isUC: false,
	},
	{
		code: "ocApplied",
		name: "OC - Applied",
		shortName: "OC (App)",
		isOc: true,
		isUC: false,
	},
	{
		code: "ocUnavailable",
		name: "OC - Unavailable",
		shortName: "OC (unAvail)",
		isOc: true,
		isUC: false,
	},
	{
		code: "ocApplicationPending",
		name: "OC - Application Pending",
		shortName: "OC (appPending)",
		isOc: true,
		isUC: true,
	},
	{
		code: "ocNotExpected",
		name: "OC - Not Expected",
		shortName: "OC (notExpec)",
		isOc: true,
		isUC: true,
	},
];
